const initialState = {
    Features: {
        isLoading: true,
        data: {},
    },
    AEMContent: {
        isLoading: true,
        data: {},
    },
    Authentication: {
        isAuthenticated: false,
        jwt: null,
        isCsr: false,
        sessionCorrelationId: null,
        isCiamSession: false,
        isSteppedUp: false,
    },
    Errors: {
        initialLoad: {},
        familyMemberUpdate: {},
        emailAddressUpdate: {},
        postalAddressUpdate: {},
        bankDataLoad: {},
        bankDataUpdate: {},
        tokenUpdate: {},
        canadaPostAddressLoad: {},
        dropDownSelectedAddressDetail: {},
        commitContext: {},
        purgeApplicationStateAndContext: {},
        terminateCIAMSession: {},
    },
    MemberData: {
        isLoadingMemberData: true,
        isLoadingSupplementalMemberData: true,
        isLoadingFamilyData: true,
        isSavingPostalAddressInformation: false,
        isSavingEmailAddress: false,
        isAddFamilyDataSaving: false,
        isEditFamilyDataSaving: false,
        isExtendCoverageDataSaving: false,
        isPurgeApplicationStateAndContextSaving: false,
        isCommitContextSaving: false,
        isLoadingMemberBenefitData: false,
        isTerminatingCIAMSession: false,
        member: {},
        allowedDependentActions: {},
        memberBenefits: [],
        familyMembers: [],
    },
    BankData: {
        isLoadingBankData: false,
        isBankValid: false,
        isSavingBankInformation: false,
        bankName: '',
    },
    CanadaPostAddress: {
        listOfAddressForSuggestionDropDown: [],
        isLoadingSuggestionDropDownAddressList: false,
        dropDownSelectedAddressDetail: {},
        isLoadingdropDownSelectedAddressDetail: false,
    },
    Context: {
        ctx: null,
        isOtip: undefined,
        ctxQueryString: null,
    },
};

const GetInitialState = () => initialState;

export default GetInitialState;
